import { Typography as AntTypography } from 'antd';
import { FC, ReactChildren, ReactNode } from 'react';

const { Text: AntdText } = AntTypography;

type Props = {
  style?: object;
  children?: ReactNode;
  font?: string;
  size?: string | number;
  level?: number;
};

export const Typography: FC<Props> = (props: any) => {
  return (
    <AntdText
      style={{
        color: `
      rgba(0,0,0,${props.level / 10})
    `,
        fontFamily: props.font,
        fontSize: props.size + 'px',
        lineHeight: props.size + 'px',
        ...props.style,
      }}
      {...props}
    >
      {props.children}
    </AntdText>
  );
};

export default Typography;
